import React from "react";
import PropTypes from "prop-types";
import Loading from "../Loading";
import { UiTable, UiTableHeader, UiTableBody, UiTableRow, UiTableItem } from "./Table.style";
/**
 * 表格組件
 */

const Table = ({
  className,
  margin,
  variant = "default",
  children,
  isSticky
}) => /*#__PURE__*/React.createElement(UiTable, {
  className: className,
  issticky: isSticky,
  mb: margin,
  variant: variant
}, children);

Table.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(["default", "light"]),
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
  isSticky: PropTypes.bool
};
export default Table;
export const TableHeader = ({
  className,
  children
}) => /*#__PURE__*/React.createElement(UiTableHeader, {
  className: className
}, children);
TableHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};
export const TableBody = ({
  className,
  children,
  isLoading
}) => /*#__PURE__*/React.createElement(UiTableBody, {
  className: className
}, isLoading ? /*#__PURE__*/React.createElement(Loading, null) : children);
TableBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  isLoading: PropTypes.bool
};
export const TableRow = ({
  className,
  children,
  isSticky
}) => /*#__PURE__*/React.createElement(UiTableRow, {
  className: className,
  issticky: isSticky
}, children);
TableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  isSticky: PropTypes.bool
};
export const TableItem = ({
  className,
  flex,
  children,
  isSticky
}) => /*#__PURE__*/React.createElement(UiTableItem, {
  className: className,
  issticky: isSticky,
  flex: flex
}, children);
TableItem.propTypes = {
  className: PropTypes.string,
  flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
  isSticky: PropTypes.bool
};